export default {"src":"/_next/static/media/QRTEB.b7115356.svg","height":18,"width":18};